import {
  faDownload,
  faEye,
  faPen,
  faTrashCan,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import SOP_Edit_Offcanvas from "../SOP_Edit_Offcanvas/SOP_Edit_Offcanvas";
import Download_offcanvas from "../../../../../../../common/common_offcanvas/download_offcanvas/Download_offcanvas";
import Delete_offcanvas from "../../../../../../../common/common_offcanvas/delete_offcanvas/Delete_offcanvas";
import SOP_view_offcanvas from "../sop_view_offcanvas/SOP_view_offcanvas";
import Pagination_Holder from "../../../../../../../common/common_components/pagination_holder/Pagination_Holder";
import {
  Create,
  GetAll,
  Delete,
} from "../../../../../../../../src/features/admin/quality_management/structural_requirement/management_data/Slice";
import { useDispatch, useSelector } from "react-redux";
import { formatDate } from "../../../../../../../utils/common";
import { FixIDS } from "../../../../../../../utils/fixIDS";

function SOP_table({ data, setCurrentPage, currentPage,fetchCustomers }) {
  // console.log("datadata",data)
  const dispatch = useDispatch();
  const [view, setView] = useState(false);
  const [viewId, setViewId] = useState(null);
  const [showEdit, setEdit] = useState(false);
  const [showEditId, setEditId] = useState(null);
  const [showDownload, setDownload] = useState(false);
  const [showDelete, setDelete] = useState(false);
  const [selectedDeleteId, setSelectedDeleteId] = useState(null);
  const [selectedDownloadId, setSelectedDownloadId] = useState(null);
  /* ================= DELETE HANDLER ================= */
  const handleDelete = async () => {
    if (!selectedDeleteId) return;

    try {
      await dispatch(Delete(selectedDeleteId)).unwrap(); // call redux thunk
      await dispatch(
        GetAll({
          management_data_id: 4,
        }),
      ); // refresh the table
      // setDelete(false); // close offcanvas
      setSelectedDeleteId(null); // reset
    } catch (err) {
      console.error("Delete failed", err);
      alert("Delete failed");
    }
  };

  const permissions = useSelector((state) => state.auth.permissions);

  const haveEditPermission = permissions?.includes(FixIDS.sop.Edit);
  const haveViewPermission = permissions?.includes(FixIDS.sop.View);
  const haveDeletePermission = permissions?.includes(FixIDS.sop.Delete);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleDownloadConfirm = async () => {
    if (!selectedDownloadId) return;

    const row = data.data.find((item) => item.id === selectedDownloadId);

    if (!row || !row.Management_Data_Documents?.length) {
      alert("File not found");
      return;
    }

    const files = row.Management_Data_Documents.map(
      (doc) => `${process.env.REACT_APP_IMG_URL}${doc.document_path}`,
    );

    for (const file of files) {
      await handleDownload(file);
    }
  };

  const handleDownload = async (imagePath) => {
    try {
      const response = await fetch(imagePath);
      const blob = await response.blob();

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");

      link.href = url;
      link.download = imagePath.split("/").pop();

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Download failed", err);
    }
  };

  return (
    <>
      <section className="Imperiality_table">
        <div className="common_table_container theme_bg">
          <div className="table-responsive">
            <table className="common_table table table-striped customer_table">
              <thead>
                <tr>
                  <th>Sr. No</th>
                  <th>Date</th>
                  <th>Document Name</th>
                  <th>Remarks</th>
                  <th>Action</th>
                </tr>
              </thead>

              <tbody>
                {data?.data.map((row, index) => (
                  <tr key={index}>
                    <td>
                      {(data?.current_page - 1) * data?.per_page + index + 1}
                    </td>

                    <td>{formatDate(row?.createdAt)}</td>

                    {/* Document Name */}
                    <td>{row?.name}</td>

                    {/* Remarks */}
                    <td>{row?.remark}</td>

                    {/* Action Icons */}
                    <td>
                      <div className="action_icons">
                        {/* VIEW → always visible */}
                        { haveViewPermission && <FontAwesomeIcon
                          icon={faEye}
                          onClick={() => {
                            setView(true);
                            setViewId(row.id);
                          }}
                        />}

                        {haveEditPermission && (
                          <FontAwesomeIcon
                            icon={faPen}
                            onClick={() => {
                              setEdit(true);
                              setEditId(row.id);
                            }}
                          />
                        )}


                        { haveDeletePermission && <FontAwesomeIcon
                          icon={faTrashCan}
                          onClick={() => {
                            setSelectedDeleteId(row.id);
                            setDelete(true);
                          }}
                        />}

                        {/* DOWNLOAD + DELETE → only if documents exist */}
                        {/* {row?.Management_Data_Documents?.length > 0 && (
                          <>
                            <FontAwesomeIcon
                              icon={faDownload}
                              onClick={() => {
                                setSelectedDownloadId(row.id);
                                setDownload(true);
                              }}
                            />
                          </>
                        )} */}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        <div className="comon_page_footer">
          <div className="show_entry_div">
            <p className="show_text">
              Showing {(data?.current_page - 1) * data?.per_page + 1} To{" "}
              {Math.min(data?.current_page * data?.per_page, data?.total)} Of{" "}
              {data?.total} Entries
            </p>
          </div>

          <div className="pagination_div">
            <Pagination_Holder
              onPageChange={data?.current_page}
              totalPages={data?.total_pages}
              handlePageChange={handlePageChange}
            />
          </div>
        </div>
      </section>

      {/* ================= VIEW ================= */}
      <SOP_view_offcanvas
        show={view}
        handleClose={() => setView(false)}
        id={viewId}
      />

      {/* ================= DOWNLOAD ================= */}
      <Download_offcanvas
        show={showDownload}
        handleClose={() => setDownload(false)}
        offcanvasHeading="Download SOP"
        massageText={"SOP"}
        onConfirm={handleDownloadConfirm}
      />

      {/* Edit */}
      {haveEditPermission && (
        <SOP_Edit_Offcanvas
        fetchCustomers={fetchCustomers}
          show={showEdit}
          handleClose={() => setEdit(false)}
          id={showEditId}
        />
      )}

      {/* ================= DELETE ================= */}
      <Delete_offcanvas
        show={showDelete}
        handleClose={() => setDelete(false)}
        handleDelete={handleDelete}
        offcanvasHeading="Delete SOP"
        massageText={"SOP"}
      />
    </>
  );
}

export default SOP_table;
